module.exports = __webpack_public_path__ + "img/seq7.cc24de44.png";